<template>
  <div class="container">
    <div class="f-sb">
      <donut-page-title title="Settings" />
    </div>
    <donut-tabs
      ref="tabsComponent"
      :tabs="tabsWithHandlers"
      :initial-tab="initialTab"
      class="m-tx4"
    >
      <template #intros>
        <user-settings-tabs-intros v-if="hasVisitedTab('intros')" />
      </template>
      <template #celebrations>
        <user-settings-tabs-celebrations v-if="hasVisitedTab('celebrations')" />
      </template>
      <template #donut-channels>
        <user-settings-tabs-donut-channels v-if="hasVisitedTab('donut-channels')" />
      </template>
    </donut-tabs>
  </div>
</template>

<script setup>
  import { computed, ref, onMounted } from 'vue';

  // Track which tabs have been visited to prevent API calls on initial load
  const visitedTabs = ref(new Set());

  const hasVisitedTab = (tabValue) => visitedTabs.value.has(tabValue);

  const markTabAsVisited = (tabValue) => {
    visitedTabs.value.add(tabValue);
  };

  const handleTabClick = (tabValue) => {
    markTabAsVisited(tabValue);
  };

  const baseTabs = [
    {
      title: 'Intros',
      value: 'intros',
    },
    {
      title: 'Celebrations',
      value: 'celebrations',
    },
    {
      title: 'Donut Channels',
      value: 'donut-channels',
    },
  ];

  const tabsWithHandlers = computed(() => baseTabs.map(tab => ({
    ...tab,
    onClick: () => handleTabClick(tab.value),
  })));

  const initialTab = computed(() => {
    const initialTabValue = Donut.QueryParams.get('tab') || 'intros';
    return baseTabs.find(tab => tab.value === initialTabValue);
  });

  // Mark the initial tab as visited
  onMounted(() => {
    markTabAsVisited(initialTab.value.value);
  });
</script>
